module.exports = __webpack_public_path__ + "img/4_11.cbfd33fa.png";